<template>
  <div class="wrapper-main">


    <section class="view-top-title">
      <div v-if="false">
        <video style="width: 100%;height: 100%;z-index: -1;position: relative;" autoplay="" loop="" muted=""
          data-src="../assets/video/index_cloud_intelligent.mp4"
          src="../assets/video/index_cloud_intelligent.mp4"></video>

        <h2 class="R2OWfDdm">智慧城市行业解决方案领导者</h2>
        <p style="position: relative;top: -180px;color: #fff;">智能硬件 + 专业软件 + 水务平台 + 行业物联网 + 全面服务</p>
      </div>

    </section>

    <div class="banner-box">
      <el-carousel height="590px">
        <el-carousel-item>
          <router-link to="/product">
            <div class="banner-item one" />
          </router-link>

        </el-carousel-item>
        <el-carousel-item>
          <router-link to="/product">
            <div class="banner-item two" />
          </router-link>
        </el-carousel-item>

        <el-carousel-item>
          <router-link to="/product">
            <div class="banner-item three" />
          </router-link>
        </el-carousel-item>
      </el-carousel>
    </div>

    <section class="g2lV7IP7">
      <h2>智慧水务一站式解决方案</h2>
      <p class="sub-title">实现从水源地到终端用户用水的全链条、一体化综合管理
        <!-- <a href="/solution/index.html" target="_blank"
          data-track-category="2022版-首页解决方案" data-track-name="副标题" data-track-value="查看全部解决方案">查看全部解决方案</a> -->
      </p>
      <div class="__0qIHuklL">
        <div class="Ziy1sLi8">
          <!-- <a v-for="(item, index) in functionList" :key="index" target="_blank" class="bbleA9G7"
            data-track-category="2022版-首页解决方案" data-track-name="正文" :data-track-value="item.title">
            <div class="mMwjHh3z">
              <img :src="`../assets/img/${item.img1}.png`" :data-src="`../assets/img/${item.img1}.png`" :alt="item.title" class="undefined">
              <div class="__0yLhEU14">
                <h3>{{ item.title }}</h3>
                <p class="desc">{{ item.content }}</p>
                <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
              </div>
            </div>
            <div class="p5DWbndU">
              <img :src="`../assets/img/${item.img2}.png`" :data-src="`../assets/img/${item.img2}.png`" :alt="item.title" class="undefined">
            </div>
          </a> -->

          <router-link to="/productDetail/1">
            <a href="http://114.115.162.140:9965/login" target="_blank" class="bbleA9G7" data-track-category="2022版-首页解决方案"
              data-track-name="正文" data-track-value="智慧水务云平台">
              <div class="mMwjHh3z">
                <img src="../assets/img/bg_mod_city.jpg" data-src="../assets/img/bg_mod_city.jpg" alt="智慧水务云平台"
                  class="undefined">
                <div class="__0yLhEU14">
                  <h3>智慧水务云平台</h3>
                  <p class="desc">展示水源地、水厂、加压泵站、水质监测、安防监控、集抄、管网监测等信息。</p>
                  <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
                </div>
              </div>
              <div class="p5DWbndU">
                <img src="../assets/img/bg_city.jpg" data-src="../assets/img/bg_city.jpg" alt="智慧水务云平台" class="undefined">
              </div>
            </a>
          </router-link>
          <router-link to="/productDetail/2">
            <a href="http://47.94.106.102/" target="_blank" class="bbleA9G7" data-track-category="2022版-首页解决方案"
              data-track-name="正文" data-track-value="集抄营收管理系统">
              <div class="mMwjHh3z">
                <img src="../assets/img/bg_mod_manufacture.jpg" data-src="../assets/img/bg_mod_manufacture.jpg"
                  alt="集抄营收管理系统" class="undefined">
                <div class="__0yLhEU14">
                  <h3>集抄营收管理系统</h3>
                  <p class="desc">实现多厂家计量设备的数据接入，为客户提供统一的设备和计量数据管理。</p>
                  <div class="IazeMdy5">
                    <span>了解详情</span>
                    <i class="DiRQYEJZ visible"></i>
                  </div>
                </div>
              </div>
              <div class="p5DWbndU">
                <img src="../assets/img/bg_manufacture.jpg" data-src="../assets/img/bg_manufacture.jpg" alt="集抄营收管理系统"
                  class="undefined">
              </div>
            </a>
          </router-link>
          <router-link to="/productDetail/3">
            <a href="http://47.94.106.102/" target="_blank" class="bbleA9G7" data-track-category="2022版-首页解决方案"
              data-track-name="正文" data-track-value="摄像直读管理系统">
              <div class="mMwjHh3z">
                <img src="../assets/img/bg_mod_energy.jpg" data-src="../assets/img/bg_mod_energy.jpg" alt="摄像直读管理系统"
                  class="undefined">
                <div class="__0yLhEU14">
                  <h3>摄像直读管理系统</h3>
                  <p class="desc">摄像直读水表抄表、识别图形、预警、指令下发。</p>
                  <div class="IazeMdy5">
                    <span>了解详情</span>
                    <i class="DiRQYEJZ visible"></i>
                  </div>
                </div>
              </div>
              <div class="p5DWbndU">
                <img src="../assets/img/bg_energy.jpg" data-src="../assets/img/bg_energy.jpg" alt="摄像直读管理系统"
                  class="undefined">
              </div>
            </a>
          </router-link>

          <router-link to="/productDetail/4">
            <a href="http://114.115.162.140:9960/" target="_blank" class="bbleA9G7"
              data-track-category="2022版-首页解决方案" data-track-name="正文" data-track-value="抄表管理系统">
              <div class="mMwjHh3z">
                <img src="../assets/img/bg_mod_water.jpg" data-src="../assets/img/bg_mod_water.jpg" alt="抄表管理系统"
                  class="undefined">
                <div class="__0yLhEU14">
                  <h3>抄表管理系统</h3>
                  <!-- 管理客户用户、水表等，并进查询费用和缴费。 -->
                  <p class="desc">实现以档案、抄表、账号、收费、报表、通知、阀门的一体化智能营业系统。</p>
                  <div class="IazeMdy5">
                    <span>了解详情</span>
                    <i class="DiRQYEJZ visible"></i>
                  </div>
                </div>
              </div>
              <div class="p5DWbndU">
                <img src="../assets/img/bg_water.jpg" data-src="../assets/img/bg_water.jpg" alt="抄表管理系统"
                  class="undefined">
              </div>
            </a>
          </router-link>

          <router-link to="/productDetail/5">
            <a href="http://47.94.106.102:83/" target="_blank" class="bbleA9G7"
              data-track-category="2022版-首页解决方案" data-track-name="正文" data-track-value="工单系统">
              <div class="mMwjHh3z"><img src="../assets/img/bg_mod_finance.jpg"
                  data-src="../assets/img/bg_mod_finance.jpg" alt="工单系统" class="undefined">
                <div class="__0yLhEU14">
                  <h3>工单系统</h3>
                  <!-- 远程控制设备 -->
                  <p class="desc">提供现场查图、设施属性查询及GIS支持，实现设备巡检、信息记录、轨迹追踪、隐患上报与处理追踪，保障设备可靠运行。</p>
                  <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
                </div>
              </div>
              <div class="p5DWbndU"><img src="../assets/img/bg_finance.jpg" data-src="../assets/img/bg_finance.jpg"
                  alt="工单系统" class="undefined"></div>
            </a>
          </router-link>

          <router-link to="/productDetail/6">
            <a href="http://114.115.219.204:8081/" target="_blank" class="bbleA9G7"
              data-track-category="2022版-首页解决方案" data-track-name="正文" data-track-value="智慧水务云平台">
              <div class="mMwjHh3z"><img src="../assets/img/bg_mod_media.jpg" data-src="../assets/img/bg_mod_media.jpg"
                  alt="设备管理平台" class="undefined">
                <div class="__0yLhEU14">
                  <h3>设备管理平台</h3>
                  <p class="desc">管理公司所有产品、设备，实现设备监测信息化流程。</p>
                  <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
                </div>
              </div>
              <div class="p5DWbndU"><img src="../assets/img/bg_media.jpg" data-src="../assets/img/bg_media.jpg"
                  alt="设备管理平台" class="undefined"></div>
            </a>
          </router-link>

          <router-link to="/productDetail/7">
            <a href="http://www.kedaxk.com/wdywgj13/" target="_blank" class="bbleA9G7" data-track-category="2022版-首页解决方案"
              data-track-name="正文" data-track-value="水务运维平台">
              <div class="mMwjHh3z"><img src="../assets/img/bg_mod_education.jpg"
                  data-src="../assets/img/bg_mod_education.jpg" alt="水务运维平台" class="undefined">
                <div class="__0yLhEU14">
                  <h3>水务运维平台</h3>
                  <p class="desc">监测设备压力、电池电压、信号等信息，并进行设备更改。</p>
                  <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
                </div>
              </div>
              <div class="p5DWbndU">
                <img src="../assets/img/bg_education.jpg" data-src="../assets/img/bg_education.jpg" alt="水务运维平台"
                  class="undefined">
              </div>
            </a>
          </router-link>

          <router-link to="/productDetail/8">

            <a href="http://114.115.247.229:8081/user/index" target="_blank" class="bbleA9G7" data-track-category="2022版-首页解决方案"
              data-track-name="正文" data-track-value="物联网装备云平台">
              <div class="mMwjHh3z"><img src="../assets/img/bg_mod_smarttransportation.jpg"
                  data-src="../assets/img/bg_mod_smarttransportation.jpg" alt="物联网装备云平台" class="undefined">
                <div class="__0yLhEU14">
                  <h3>物联网装备云平台</h3>
                  <p class="desc">实现终端设备、项目、触发器的管理平台。</p>
                  <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
                </div>
              </div>
              <div class="p5DWbndU">
                <img src="../assets/img/bg_smarttransportation.jpg" data-src="../assets/img/bg_smarttransportation.jpg"
                  alt="物联网装备云平台" class="undefined">
              </div>
            </a>
          </router-link>

          <router-link to="/productDetail/9">

            <a href="http://www.kedaxk.com:8003/Home/Login" target="_blank" class="bbleA9G7" data-track-category="2022版-首页解决方案"
              data-track-name="正文" data-track-value="水务管理系统">
              <div class="mMwjHh3z"><img src="../assets/img/bg_mod_dianxin.jpg"
                  data-src="../assets/img/bg_mod_dianxin.jpg" alt="水务管理系统" class="undefined">
                <div class="__0yLhEU14">
                  <h3>水务管理系统</h3>
                  <p class="desc">展示水源地、水厂、加压泵站、水质监测、安防监控、集抄、管网监测等信息。</p>
                  <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
                </div>
              </div>
              <div class="p5DWbndU"><img src="../assets/img/bg_dianxin.jpg" data-src="../assets/img/bg_dianxin.jpg"
                  alt="水务管理系统" class="undefined"></div>
            </a>
          </router-link>

          <a target="_blank" class="bbleA9G7" data-track-category="2022版-首页解决方案" data-track-name="正文"
            data-track-value="智慧云水厂">
            <div class="mMwjHh3z"><img src="../assets/img/bg_mod_cloud.jpg" data-src="../assets/img/bg_mod_cloud.jpg"
                alt="智慧云水厂" class="undefined">
              <div class="__0yLhEU14">
                <h3>智慧云水厂</h3>
                <!-- 为企业数智化升级提供安全稳定、弹性灵活的云计算服务。 -->
                <p class="desc">争做行业标杆，共创行业领先的现代化智慧水务。</p>
                <div class="IazeMdy5"><span>了解详情</span><i class="DiRQYEJZ visible"></i></div>
              </div>
            </div>
            <div class="p5DWbndU">
              <img src="../assets/img/bg_cloud.jpg" data-src="../assets/img/bg_cloud.jpg" alt="更多" class="undefined">
            </div>
          </a>
        </div>
      </div>
    </section>

    <!-- <h1>Home Page</h1>    -->
    <!-- <float-view :json="json" /> -->
    <BackTop />
  </div>
</template>

<script>
import FloatView from '@/components/FloatView'
import BackTop from '@/components/BackTop'

export default {
  name: 'Home',
  components: { BackTop, FloatView },
  data() {
    return {
      json: {
        src: 'https://www.ssdfz.net/ImageFiles/20180419130336830.jpg',
        url: 'http://www.baidu.com',
        left: 100,
        top: 400,
        directionX: 0.5,
        directionY: 0.5,
        distance: null,
        interval: 11,
        target: null,
        zIndex: null,
        width: null,
        height: null,
        noHoverPause: null, // 鼠标经过时不停止，为true时不停止
        cursor: null
      },
      functionList: [
        {
          title: "设备管理平台",
          img1: "../assets/img/bg_mod_city.jpg",
          content: "以城市大脑2.0为引擎，全面助力城市数字化转型升级。",
          img2: "../assets/img/bg_city.jpg"
        }
      ]
    }
  }
}
</script>
<style type="text/less" lang="less">
@import "../assets/css/home.less";

.view-top-title {
  z-index: 1;
  padding: 0;
  // margin-top: 52px;
  height: 0px;
  display: block;
  text-align: center;
}



.R2OWfDdm {
  font-family: PingFangSC-Semibold;
  font-size: 36px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  font-weight: 600;
  margin-bottom: 24px;
  position: relative;
  top: -180px;
}
</style>
